export const CHECKOUT_STEP_FOCUS_EXPERIMENT_KEY = 'dev-57515-checkout-improvements-ecp';
export const CHECKOUT_STEP_FOCUS_SALES_CHANNEL_ID = 'web-kfzteile24-de';

